import {Directive, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Subject, Subscription} from 'rxjs';
import {throttleTime} from 'rxjs/operators';

@Directive({
  selector: '[appThrottleClick]'
})
export class ThrottleClickDirective implements OnInit, OnDestroy {

  @Input()
  time = 60000;

  @Output()
  clickFunction = new EventEmitter();

  private clicks = new Subject();
  private subscription!: Subscription;


  ngOnInit(): void {
    this.subscription = this.clicks
      .pipe(
        throttleTime(this.time),
      )
      .subscribe(event => {
        this.clickFunction.emit(event)
      });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  @HostListener('click', ['$event'])
  clickEvent(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.clicks.next(event);
  }

}
